// src/icons/svgs/horizontal-line.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgHorizontalLine = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "none", viewBox: "0 0 28 28", ref, ...props, children: /* @__PURE__ */ jsx("path", { stroke: "#495057", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.56, d: "M3 14h4M12 14h4M21 14h4" }) });
var ForwardRef = forwardRef(SvgHorizontalLine);
var horizontal_line_default = ForwardRef;
export {
  horizontal_line_default as HorizontalLine
};
